var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VMenu',_vm._g(_vm._b({class:_vm.classList,attrs:{"attach":true},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_vm._t("activator",null,null,data)]}}],null,true)},'VMenu',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }